type ImageComponentProps = {
  width?: string;
  url?: string;
  url2?: string;
  pointer?: string;
  maxWidth?: string;
  imgWidth?: string;
  maxWidthImage?: string;
  maxwidthImg?: string;
  marginContainer?: string;
  marginDesktop?: string;
  id?: string;
  href?: string;
  href2?: string;
  marginMobile?: string;
};

export const ImageComponent = ({
  width,
  url,
  url2,
  pointer,
  maxWidth,
  imgWidth,
  maxWidthImage,
  maxwidthImg,
  marginContainer,
  marginDesktop,
  id,
  href,
  href2,
  marginMobile
}: ImageComponentProps) => {
  return (
    <div className="image-container" id={id}>
      <a href={href}>
        <img className="image-container-image" src={url}></img>
      </a>
      {url2 ? (
        <a href={href2}>
          <img src={url2}></img>{" "}
        </a>
      ) : (
        <></>
      )}
      <style jsx>{`
        .image-container-image {
          width: ${imgWidth};
          margin: ${marginDesktop};
        }
        .image-container {
          display: flex;
          justify-content: center;
          margin: ${marginContainer ? marginContainer : '16px'};
          width: ${width ? width : "auto"};
          cursor: ${pointer ? "pointer" : ""};
        }
        .image-container img {
          padding: 0 10px;
          max-width: ${maxWidth ? "380px" : ""};
        }
        .image-container-image {
          max-width: ${maxwidthImg};
        }
        @media only screen and (max-width: 600px) {
          .image-container-image {
            margin: ${marginMobile};
          }
          .image-container {
            flex-direction: column;
            align-items: center;
          }
          .image-container-image {
            margin: ${marginMobile};
          }
          .image-container img {
            max-width: ${maxWidthImage ? maxWidthImage : "155px"};
            padding: 10px 0 0 0;
          }
        }
      `}</style>
    </div>
  );
};
